import { UserOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'
import React from 'react'

interface Props {
  size?: number
  user: {
    avatar?: string | null
  }
}

export const UserAvatar: React.FC<Props> = (props) => {
  return props.user?.avatar ? (
    <Avatar size={props.size} icon={<img src={props.user.avatar} alt={'Avatar'} />} />
  ) : (
    <Avatar size={props.size} icon={<UserOutlined />} />
  )
}
